(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sword-discount-wheel"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(){
    const dialog=document.getElementById('sword-wheel-dialog');
    const launch=document.getElementById('sword-wheel-launch');
    if(!dialog || !launch || dialog.dataset.ready) return;
    dialog.dataset.ready='true';
    const spin=dialog.querySelector('.sw-spin');
    const wheel=dialog.querySelector('.sw-wheel');
    const result=dialog.querySelector('.sw-result');
    const prizes=[5,10,15,5,10,15];
    const key='sword-wheel-first-v1';
    let prize=null;
    let spinning=false;
    let openedBy=null;
    const get=(storage,name)=>{try{return window[storage].getItem(name);}catch{return null;}};
    const set=(storage,name,value)=>{try{window[storage].setItem(name,value);}catch{}};
    const saved=Number(get('localStorage',key));
    if([5,10,15].includes(saved)) prize=saved;
    function celebrate(){
      const layer=dialog.querySelector('.sw-celebration');
      layer.replaceChildren();
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      const colors=['#c5222b','#9751b5','#247ca1','#b27616'];
      for(let i=0;i<8;i++){
        const balloon=document.createElement('span');
        balloon.className='sw-balloon';
        balloon.textContent=prize+'%';
        balloon.style.setProperty('--x',(4+i*12)+'%');
        balloon.style.setProperty('--delay',(i*.14)+'s');
        balloon.style.setProperty('--balloon-color',colors[i%colors.length]);
        balloon.addEventListener('animationend',()=>balloon.remove(),{once:true});
        layer.appendChild(balloon);
      }
    }
    function showPrize(){
      if(!prize) return;
      dialog.querySelector('.sw-prize-percent').textContent=prize+'%';
      spin.hidden=true;
      result.hidden=false;
      dialog.querySelector('.sw-win').textContent='¡Ganaste un '+prize+'% de descuento!';
      dialog.querySelector('.sw-code').textContent='SWORDGIRA'+prize;
      dialog.querySelector('.sw-apply').href='/discount/SWORDGIRA'+prize+'?redirect=%2Fcollections%2Fall';
      launch.textContent='🎁 Tu descuento: '+prize+'%';
    }
    function open(){
      if(dialog.open) return;
      openedBy=document.activeElement;
      dialog.showModal();
      set('sessionStorage',key+'-seen','1');
    }
    function close(){
      dialog.close();
      dialog.querySelector('.sw-celebration').replaceChildren();
      if(openedBy && openedBy.isConnected) openedBy.focus();
    }
    launch.addEventListener('click',open);
    dialog.querySelector('.sw-close').addEventListener('click',close);
    dialog.addEventListener('click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)close();}});
    spin.addEventListener('click',()=>{
      if(spinning || prize) return;
      spinning=true;
      spin.disabled=true;
      spin.textContent='GIRANDO…';
      const i=Math.floor(Math.random()*prizes.length);
      prize=prizes[i];
      set('localStorage',key,String(prize));
      wheel.style.transform='rotate('+(1800+360-(i*60+30))+'deg)';
      const done=()=>{spinning=false;showPrize();if(dialog.open)celebrate();};
      window.setTimeout(done,window.matchMedia('(prefers-reduced-motion: reduce)').matches?0:4100);
    });
    showPrize();
    if(!get('sessionStorage',key+'-arrival-v2')){
      const arrive=()=>{
        if(document.querySelector('dialog[open]')){window.setTimeout(arrive,200);return;}
        set('sessionStorage',key+'-arrival-v2','1');
        open();
      };
      arrive();
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

})();
